module.exports = __webpack_public_path__ + "img/menu-page-1.0ec67f91.png";